// 校管家APP环境

import xah from './xgj-app-sdk/sdk.js';

import base from '@mlib/js/base/base.js';
import BaseClass from './baseClass/baseClass.js';

var xgjsdk,
  u = new BaseClass();

if (base.env === 'xgj') {
  // 获取版本号
  u.getAppVersion = function(opt = {}) {
    return new Promise((resolve, reject) => {
      if (window._xgj_.getAppVersion) {
        xah.getAppVersion({
          complete: res => {
            if (res.code === 0) {
              resolve(res.data);
            } else {
              console.warn('调用 xgj.getAppVersion 失败... ', res);
              reject(res);
            }
          },
        });
      } else {
        resolve('');
      }
    });
  };
  // 检查更新
  u.checkVersionUpdate = function(opt = {}) {
    return new Promise((resolve, reject) => {
      if (window.xgj.checkVersionUpdate) {
        xah.checkVersionUpdate({
          complete: res => {
            if (res.code === 0) {
              resolve(res.data.versionName);
            } else {
              console.warn('调用 xgj.checkVersionUpdate 失败... ', res);
              reject(res);
            }
          },
        });
      } else {
        resolve('');
      }
    });
  };
  // 获取渠道信息字串
  u.getChannelString = function(opt = {}) {
    return new Promise((resolve, reject) => {
      if (window.xgj.getChannelString) {
        xah.getChannelString({
          complete: res => {
            if (res.code === 0) {
              resolve(res.data);
            } else {
              console.warn('调用 xgj.getChannelString 失败... ', res);
              reject(res);
            }
          },
        });
      } else {
        resolve('');
      }
    });
  };

  // app上传OSS获取凭证用，需要业务层配置
  u.getOssStsToken = function() {
    console.error('请设置上传OSS的policy方法，该方法必须返回一个resolve出policy的promise');
  };

  // 通过config接口注入权限验证配置
  u.setConfig = function(opts) {};

  // 通过微信菜单分享
  u.onWXMenuShare = function(opt) {
    /*opt = {
        title: '', // 分享标题
        desc: '', // 分享描述
        link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: '', // 分享图标
        success: function () { 
            // 用户确认分享后执行的回调函数
        }
    }*/

    // 分享给朋友
    xah.updateAppMessageShareData(opt);
    // 分享到朋友圈
    xah.updateTimelineShareData(opt);
  };

  // 隐藏或显示右上角菜单
  u.triggerMenu = function(bool = false) {
    xah.showOptionMenu({
      show: bool,
    });
  };

  // 分享
  u.share = function(opt) {
    /*opt = {
        title: '', // 分享标题
        desc: '', // 分享描述
        link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: '', // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
    }*/
    u.triggerMenu(true);
    u.onWXMenuShare(opt);
  };

  // 预览图片
  u.previewImage = function(opt = {}) {
    xah.previewImages({
      current: opt.current,
      urls: opt.urls,
    });
  };

  // 选择图片
  u.chooseImage = function(opt = {}) {
    let option = JSON.parse(JSON.stringify(opt));
    option.count = option.max || 9;
    delete option.max;
    return new Promise((resolve, reject) => {
      xah.chooseImage({
        ...option,
        complete: res => {
          res.code === 0 ? resolve(res.data) : reject(res);
        },
      });
    });
  };

  // 选择视频
  u.chooseVideo = function(opt = {}) {
    let option = JSON.parse(JSON.stringify(opt));
    option.count = option.max || 1;
    delete option.max;
    return new Promise((resolve, reject) => {
      xah.chooseVideo({
        ...option,
        complete: res => {
          res.code === 0 ? resolve(res.data) : reject(res);
        },
      });
    });
  };

  // 下载视频
  u.downloadVideo = function(opt = {}) {
    console.log(opt);
    return new Promise((resolve, reject) => {
      xah.downloadVideo({
        ...opt,
        complete: res => {
          console.log(res);
          res.code === 0 ? resolve(res.data) : reject(res);
        },
      });
    });
  };

  // 开始录音
  u.startRecord = function(opt = {}) {
    return new Promise((resolve, reject) => {
      xah.startRecord({
        maxTime: opt.maxTime || 60,
        complete: res => {
          res.code === 0 ? resolve({ status: 'success' }) : reject(res);
        },
      });
    });
  };

  // 停止录音
  u.stopRecord = function() {
    return new Promise((resolve, reject) => {
      xah.stopRecord({
        complete: res => {
          // console.log('app 录音结果 -> ', res);
          if (res.code === 0) {
            let file = res.data;
            file.duration = Math.ceil(file.duration / 1000);
            resolve({
              status: 'success',
              localId: file.localId,
              file: file,
            });
          } else {
            resolve({ status: 'fail' });
          }
        },
      });
    });
  };

  // 监听录音自动停止, 录音时间超过一分钟没有停止的时候会执行 complete 回调
  u.onRecordEnd = function() {
    return new Promise((resolve, reject) => {
      xah.onVoiceRecordEnd({
        complete: res => {
          let file = res.data;
          file.duration = Math.ceil(file.duration / 1000);
          resolve({
            status: 'success',
            localId: file.localId,
            file: file,
          });
        },
      });
    });
  };

  // 播放语音
  u.playVoice = function(localId) {
    return new Promise((resolve, reject) => {
      xah.playVoice({
        url: localId,
        complete: res => {
          if (res.code === 0) {
            resolve({
              status: 'success',
            });
          } else {
            reject({
              status: 'fail',
            });
          }
        },
      });
    });
  };

  // 暂停播放
  u.pauseVoice = function(localId) {
    return new Promise((resolve, reject) => {
      xah.pauseVoice({
        url: localId,
        complete: res => {
          if (res.code === 0) {
            resolve({
              status: 'success',
            });
          } else {
            reject({
              status: 'fail',
            });
          }
        },
      });
    });
  };

  // 停止播放
  u.stopVoice = function(localId) {
    return new Promise((resolve, reject) => {
      xah.stopVoice({
        url: localId,
        complete: res => {
          if (res.code === 0) {
            resolve({
              status: 'success',
            });
          } else {
            reject({
              status: 'fail',
            });
          }
        },
      });
    });
  };

  // 监听语音播放完毕
  u.onVoicePlayEnd = function() {
    return new Promise((resolve, reject) => {
      xah.onVoicePlayEnd({
        complete: res => {
          if (res.code === 0) {
            resolve({
              status: 'success',
              localId: res.localId,
            });
          } else {
            reject({
              status: 'fail',
            });
          }
        },
      });
    });
  };

  // 关闭当前窗口
  u.closeWindow = function() {
    xah.closeWindow();
  };

  // 网页回退
  u.goBack = function() {
    xah.goBack();
  };

  // 修改标题
  u.setTitle = function(titleStr) {
    xah.setAppTitle({
      title: titleStr,
    });
  };

  // APP跳转微信小程序
  u.openMiniProgram = function(opt = {}) {
    let params = JSON.parse(JSON.stringify(opt));
    return new Promise((resolve, reject) => {
      if (window._xgj_.openMiniProgram) {
        xah.openMiniProgram({
          ...params,
          complete: res => {
            if (res.code === 0) {
              resolve(res);
            } else {
              console.warn('调用 xgj.openMiniProgram 失败... ', res);
              vant.Dialog.alert({
                message: '跳转失败，请前往微信搜索小程序“AI成长粒”。',
              }).then(() => {
                reject(res);
              });(res);
            }
          },
        });
      } else {
        resolve('');
      }
    });
  };
}

xgjsdk = u;

export default xgjsdk;
